import axios from "axios";
import { serverApi } from "../../../config/Keys";
import {
  ADD_PAGE_EXPERIENCE,
  CLEAR_ERRORS,
  CLEAR_LOADER,
  EXPERIENCE_MANAGEMENT_ARCHIVED_DATA_ADMIN,
  EXPERIENCE_MANAGEMENT_DATA_ADMIN,
  GET_PAGE_EXPERIENCE,
  SET_LOADER,
  UPDATE_PAGE_EXPERIENCE,
} from "../../types";
import { errorAlert, successAlert } from "../../../function/alert";

export const add_page = (formData, token, onSuccess) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let _response = await axios.post(
      `${serverApi}/admin/experience`,
      formData,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    if (_response.status === 201) {
      dispatch({ type: CLEAR_LOADER });
      dispatch({ type: ADD_PAGE_EXPERIENCE, payload: _response.data });
      onSuccess();
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    errorAlert("Please provide proper details.");
  }
};

export const edit_page = (formData, token, onSuccess) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let _response = await axios.patch(
      `${serverApi}/admin/experience/${formData?._id}`,
      formData,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    if (_response.status === 200) {
      dispatch({ type: CLEAR_LOADER });
      // dispatch({ type: ADD_PAGE_EXPERIENCE, payload: _response.data });
      onSuccess();
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    errorAlert("Please provide proper details.");
  }
};


export const get_pages = (token, type, onSuccess) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let _response = await axios.get(
      `${serverApi}/admin/experience?type=${type}`,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    if (_response.status === 200) {
      dispatch({ type: CLEAR_LOADER });
      dispatch({ type: GET_PAGE_EXPERIENCE, payload: _response.data });
      if (onSuccess) onSuccess(_response.data);
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    errorAlert("Please provide proper details.");
  }
};

export const get_single_page = (token, ID, onSuccess) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let _response = await axios.get(`${serverApi}/admin/experience/${ID}`, {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });
    if (_response.status === 200) {
      dispatch({ type: CLEAR_LOADER });
      dispatch({ type: UPDATE_PAGE_EXPERIENCE, payload: _response.data });
      if(onSuccess) onSuccess(_response?.data);
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    errorAlert("Please provide proper details.");
  }
};

export const add_section =
  (page_id, formData, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let _response = await axios.patch(
        `${serverApi}/admin/experience/${page_id}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (_response.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        dispatch({ type: UPDATE_PAGE_EXPERIENCE, payload: _response.data });
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      errorAlert("Please provide proper details.");
    }
  };

export const getExperiencesInRestaurant = async (
  restaurant_id,
  token,
  onSuccess
) => {
  try {
    let _response = await axios.get(
      `${serverApi}/experience?type=searchList&searchBy=${restaurant_id}`,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    if (_response.status === 200) {
      onSuccess(_response.data);
    }
  } catch (err) {
    errorAlert("Please provide proper details.");
  }
};

export const getExperiencesInRestaurantForShorts = async (
  restaurant_id,
  token,
  onSuccess
) => {
  try {
    let _response = await axios.get(
      `${serverApi}/experience?type=searchList&searchBy=${restaurant_id}&shortVideos=true`,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    if (_response.status === 200) {
      onSuccess(_response.data);
    }
  } catch (err) {
    errorAlert("Please provide proper details.");
  }
};

export const add_experience_to_section =
  (type, page_id, formData, token, onSuccess, onError) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let _response = await axios.patch(
        `${serverApi}/admin/experience/${page_id}?type=${type}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (_response.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        dispatch({ type: UPDATE_PAGE_EXPERIENCE, payload: _response.data });
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      errorAlert("Please provide proper details.");
      if (onError) onError(err);
    }
  };

export const get_experiences_in_section_from_pages = async (
  page_id,
  section_id,
  token,
  onSuccess
) => {
  try {
    let _response = await axios.get(
      `${serverApi}/admin/experience/${page_id}?section_id=${section_id}`,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    if (_response.status === 200) {
      onSuccess(_response.data);
    }
  } catch (err) {
    errorAlert("Please provide proper details.");
  }
};

export const update_experiences_in_section_from_pages = async (
  page_id,
  formData,
  token,
  type,
  onSuccess,
  source
) => {
  try {
    let _response = await axios.patch(
      `${serverApi}/admin/experience/${page_id}?type=${type}&source=${source}`,
      formData,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    if (_response.status === 200) {
      successAlert("Updated successfully..!");
      onSuccess(_response.data);
    }
  } catch (err) {
    errorAlert("Please provide proper details.");
  }
};

/**********************************************
 * @DESC SUPER ADMIN PENDING EXPERIENCE ACTIVITY REPORT APIS
 *********************************************/

export const get_pending_exp_activity = async (
  token,
  type,
  startDate,
  endDate
) => {
  try {
    let _response = await axios.get(
      `${serverApi}/admin/experience?type=${type}&startDate=${startDate}&endDate=${endDate}`,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    if (_response.status === 200) {
      return _response.data;
    }
  } catch (err) {
    errorAlert("Please provide proper details.");
  }
};

/**********************************************
 * @DESC SUPER ADMIN EXPERIENCE MANAGEMENT
 *********************************************/
export const get_experiences_admin =
  (token, type, startDate, endDate) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let _response = await axios.get(
        `${serverApi}/admin/experience?type=${type}&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (_response.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type:
            type === "EXPERIENCES"
              ? EXPERIENCE_MANAGEMENT_DATA_ADMIN
              : EXPERIENCE_MANAGEMENT_ARCHIVED_DATA_ADMIN,
          payload: _response.data,
        });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      errorAlert("Please provide proper details.");
    }
  };
